import type { IncidenceOptionsType } from 'modules/bookkeepers/lib/incidenceOptions'
import { incidenceTrackingBlocked } from 'modules/bookkeepers/lib/incidenceTrackingBlocked'
import { translatedHelpers } from 'modules/bookkeepers/lib/translationHelpers'
import { DEFAULT_CHANGE_TYPES } from 'modules/payroll_bundle/lib/Incidences/Types'

export const useGetDefaultIncidenceOptions = (): IncidenceOptionsType[] => {
  return Object.keys(DEFAULT_CHANGE_TYPES).map((key: string) => {
    return {
      id: key,
      name: key,
      identifier: key,
      disabled: incidenceTrackingBlocked(key),
      ...translatedHelpers(key),
    }
  })
}
